@import 

<template>
  <div style="font-family: 'Roboto', serif;" class="pure-g">
    <div class="pure-u-1-5"></div>
    <div class="pure-u-3-5">
      <br> The Corbin brothers have been making music together since they were kids, here is a selection of their releases and experimental projects.
      <br>
    </div>
    <div class="pure-u-1-5"></div>
    <div class="pure-u-1">
      <div class="pure-u-lg-1-4 pure-u-md-1-3 pure-u-sm-1-2" v-for="album in albums" v-bind:key=album.id>
        <AlbumListItem :albumData=album />
      </div>
    </div>
  </div>
</template>

<script>
import AlbumListItem from "./AlbumListItem";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Albums",
  data() {
    return {
      msg: "Three Brothers Music"
    };
  },
  methods: {
    ...mapGetters([
      // Mounts the "allAlbums" getter to the scope of your component.
      "allAlbums"
    ])
  },
  components: {
    AlbumListItem
  },
  computed: mapState({
    albums(state) {
      return state.albums.album_array;
    }
  })
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Albums.vue